import React, { useMemo } from "react";
import _ from 'lodash';
import GenericPullConfigListing from "../GenericPullConfigListing";
import QualysPolicyComplianceCredentialsForm from "./QualysPolicyComplianceCredentialsForm";
import QualysPolicyComplianceMappingForm from "./QualysPolicyComplianceMappingForm";
import { CellRenderers } from 'utils/tableUtils';
import ContentOverlay from 'components/ContentOverlay';

const QualysPolicyComplianceConfigListing = (props) => {
  const columns = useMemo(() => [
    {
      title: "Policy Mappings",
      dataIndex: "policyprefix",
      width: 250,
      render: (policyprefix, record) => {
        if (_.isEmpty(policyprefix)) {
            return CellRenderers.VALUE_OR_NA(policyprefix);
        }
        const hostMap = {};
        if (record.hostids) {
            const prefixes = _.split(record.policyprefix, ',');
            const hostGroups = _.split(record.hostids, ',');
            _.forEach(prefixes, (prefix, index) => {
                hostMap[prefix] = hostGroups[index];
            });
        }
        const renderContent = _.split(policyprefix, ',').map((prefix, index) => {
            const hostGroup = hostMap[prefix];
            const display = hostGroup 
                ? `${prefix} - [${hostGroup.replace(/:/g, ', ')}]` 
                : prefix;
            return <p key={`${index}`}>{display}</p>;
        });
        return <ContentOverlay content={renderContent} minHeight={40} />;
      }
    }
  ], []);

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={QualysPolicyComplianceMappingForm}
      extraColumns={columns}
      CredentialsForm={QualysPolicyComplianceCredentialsForm}
    />
  );
};

export default QualysPolicyComplianceConfigListing;
